<template>
  <div>
    <div v-for="(item, index) in splitedList" :key="index">
      <!-- <div v-if="item.includes('.png') || item.includes('.jpg')">
        <v-img height="150" width="200" :src="res_image + item"></v-img>
        <a :href="res_image + item" target="_blank">download</a>
      </div> -->
      <div v-if="isImage(item)">
        <v-img height="150" width="200" :src="res_image + item"></v-img>
        <a :href="res_image + item" target="_blank">Download</a>
      </div>
      <div v-else-if="isAudio(item)">
        <audio width="200" controls>
          <source :src="res_audio + item" type="audio/mp3" />
          Your browser does not support HTML audio.
        </audio>
        <br />
        <a :href="res_audio + item" target="_blank">Download</a><br />
      </div>
      <!-- <div v-else-if="item.includes('.mp3')">
        <audio width="200" controls>
          <source :src="res_audio + item" type="audio/mp3" />
          Your browser does not support HTML audio.</audio
        ><br />
        <a :href="res_audio + item" target="_blank">download</a><br />
      </div> -->
      <div v-else-if="isVideo(item)">
        <video width="200" controls>
          <source :src="res_video + item" type="video/mp4" />
          Your browser does not support HTML video.
        </video>
        <br />
        <a :href="res_video + item" target="_blank">Download</a><br />
      </div>
      <!-- <div v-else-if="item.includes('.mp4')">
        <video width="200" controls>
          <source :src="res_video + item" type="video/mp4" />
          Your browser does not support HTML video.</video
        ><br />
        <a :href="res_video + item" target="_blank">download</a><br />
      </div> -->
      <div v-else-if="isDocument(item)">
        <a :href="res_file + item" target="_blank" :download="item">
          <i :class="getIconClass(item)"></i> Open {{ getFileType(item) }} File
        </a>
        <br />
        <a :href="res_file + item" target="_blank">Download</a><br />
      </div>
      <!-- <div v-else-if="item.includes('.xls')">
        <a :href="res_file + item" target="_blank" download
          ><i class="fas fa-file-excel"></i> Open XLS File</a
        >
        <br />
        <a :href="res_file + item" target="_blank">Download</a><br />
      </div>
      <div v-else-if="item.includes('.xlsx')">
        <a :href="res_file + item" target="_blank" download
          ><i class="fas fa-file-excel"></i> Open XLSX File</a
        >
        <br />
        <a :href="res_file + item" target="_blank">Download</a><br />
      </div>
      <div v-else-if="item.includes('.ppt')">
        <a :href="res_file + item" target="_blank" download
          ><i class="fas fa-file-powerpoint"></i> Open PPT File</a
        >
        <br />
        <a :href="res_file + item" target="_blank">Download</a><br />
      </div>
      <div v-else-if="item.includes('.pptx') || item.includes('.ppt')">
        <a :href="res_file + item" target="_blank" download
          ><i class="fas fa-file-powerpoint"></i> Open PPTX File</a
        >
        <br />
        <a :href="res_file + item" target="_blank">Download</a><br />
      </div>
      <div v-else-if="item.includes('.pdf')">
        <a :href="res_file + item" target="_blank" download
          ><i class="fas fa-file-pdf"></i> Open PDF File</a
        >
        <br />
        <a :href="res_file + item" target="_blank">Download</a><br />
      </div>

      <div v-else-if="item.includes('.doc')">
        <a :href="res_file + item" target="_blank" download="file.doc"
          ><span class="material-icons"> picture_as_docx </span>Open DOC File</a
        >
        <br />
        <a :href="res_file + item" target="_blank">download</a><br />
      </div>
      <div v-else-if="item.includes('.docx')">
        <a :href="res_file + item" target="_blank" download="file.docx"
          ><span class="material-icons"> picture_as_docx </span>Open DOCX
          File</a
        >
        <br />
        <a :href="res_file + item" target="_blank">download</a><br />
      </div> -->
      <div v-else-if="item.includes('.csv')">
        <a :href="res_file + item" target="_blank" download="file.csv"
          ><span class="material-symbols-outlined"> csv </span>Open CSV File</a
        >
        <br />
        <a :href="res_file + item" target="_blank">download</a><br />
      </div>
      <div v-else>
        <span> {{ item }} <br /> </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["multipleData", "res_image", "res_audio", "res_video", "res_file"],
  computed: {
    ...mapGetters(["indexData"]),
    splitedList: function () {
      return (this.multipleData || "").split("|");
    },
  },
  methods: {
    isImage(item) {
      return item.includes(".png") || item.includes(".jpg");
    },
    isAudio(item) {
      return item.includes(".mp3");
    },
    isVideo(item) {
      return item.includes(".mp4");
    },
    isDocument(item) {
      return (
        item.includes(".xls") ||
        item.includes(".xlsx") ||
        item.includes(".ppt") ||
        item.includes(".pptx") ||
        item.includes(".pdf") ||
        item.includes(".doc") ||
        item.includes(".docx") ||
        item.includes(".xls") ||
        item.includes(".xlsx") ||
        item.includes(".csv")
      );
    },
    getFileType(item) {
      const extension = item.split(".").pop();
      return extension.toUpperCase();
    },
    getIconClass(item) {
      if (item.includes(".xls") || item.includes(".xlsx")) {
        return "fas fa-file-excel";
      } else if (item.includes(".ppt") || item.includes(".pptx")) {
        return "fas fa-file-powerpoint";
      } else if (item.includes(".pdf")) {
        return "fas fa-file-pdf";
      } else if (item.includes(".doc")) {
        return "fas fa-file-word";
      }
      return "";
    },
  },
};
</script>
<style lang=""></style>
